const SIGN_IN_PAGE = '/signin'
const SIGN_OUT_PAGE = '/signout'
const AUTH_PAGE = '/auth'

const BASIC_DASHBOARD = '/dashboard'

const HOME_PAGE = '/'
const ALARMS_PAGE = '/alarms'
const FACILITIES_PAGE = '/facilities'
const REALTIME_PAGE = '/realtime'
const REPORTS_PAGE = '/reports'
const USERS_PAGE = '/users'

const BMS_SETTINGS_PAGE = '/settings/bms'
const FACILITIES_SETTINGS_PAGE = '/settings/facilities'
const PHOTOVOLTAIC_SETTINGS_PAGE = '/settings/photovoltaic'
const PLC_SETTINGS_PAGE = '/settings/plc'
const USERS_SETTINGS_PAGE = '/settings/users'

const ALL_PAGES = [
    SIGN_IN_PAGE,
    SIGN_OUT_PAGE,
    AUTH_PAGE,
    BASIC_DASHBOARD,
    HOME_PAGE,
    ALARMS_PAGE,
    FACILITIES_PAGE,
    REALTIME_PAGE,
    REPORTS_PAGE,
    USERS_PAGE,
    BMS_SETTINGS_PAGE,
    FACILITIES_SETTINGS_PAGE,
    PHOTOVOLTAIC_SETTINGS_PAGE,
    PLC_SETTINGS_PAGE,
    USERS_SETTINGS_PAGE,
]

const USER_ALLOWED_PAGES = [BASIC_DASHBOARD, SIGN_IN_PAGE, SIGN_OUT_PAGE]
const USER_FORBIDDEN_PAGES = ALL_PAGES.filter((page) => !USER_ALLOWED_PAGES.includes(page))

const OPERATOR_ALLOWED_PAGES = [
    ...USER_ALLOWED_PAGES,
    HOME_PAGE,
    ALARMS_PAGE,
    FACILITIES_PAGE,
    REALTIME_PAGE,
    REPORTS_PAGE,
    USERS_PAGE,
]
const OPERATOR_FORBIDDEN_PAGES = ALL_PAGES.filter((page) => !OPERATOR_ALLOWED_PAGES.includes(page))

const ADMIN_ALLOWED_PAGES = ALL_PAGES
const ADMIN_FORBIDDEN_PAGES: string[] = []

export {
    ADMIN_ALLOWED_PAGES,
    ADMIN_FORBIDDEN_PAGES,
    ALARMS_PAGE,
    ALL_PAGES,
    BASIC_DASHBOARD,
    BMS_SETTINGS_PAGE,
    FACILITIES_PAGE,
    FACILITIES_SETTINGS_PAGE,
    HOME_PAGE,
    OPERATOR_ALLOWED_PAGES,
    OPERATOR_FORBIDDEN_PAGES,
    PHOTOVOLTAIC_SETTINGS_PAGE,
    PLC_SETTINGS_PAGE,
    REALTIME_PAGE,
    REPORTS_PAGE,
    SIGN_IN_PAGE,
    SIGN_OUT_PAGE,
    USERS_PAGE,
    USERS_SETTINGS_PAGE,
    USER_ALLOWED_PAGES,
    USER_FORBIDDEN_PAGES,
}
